<template>
    <div>
        <Tooltip transfer :content="!is_face_imgs?$t('l.remark65'):$t('l.remark66')" placement="top">
            <Avatar shape="square" size="small" style="height: 26px;width: 26px;font-size: 16px;" icon="ios-person" :style="{backgroundColor:!is_face_imgs?'':'#3399ff'}"></Avatar>
        </Tooltip>
    </div>
</template>

<script>
    export default {
        name: "face_data_imgs",
        props:{
            is_face_imgs:Number
        }
    }
</script>

<style scoped>

</style>